import { process } from "@progress/kendo-data-query"
import {
  Grid,
  GridColumn as Column,
  GridNoRecords,
  GridHeaderCell,
} from "@progress/kendo-react-grid"
import { Checkbox } from "@material-ui/core"
import { ExcelExport } from "@progress/kendo-react-excel-export"
import "@progress/kendo-theme-bootstrap/dist/all.css"
import SwitchCell from "./SwitchCell"
import SwitchCellDisabled from "./SwitchCellDisabled"
import CheckboxCell from "./CheckboxCell"
import CustomText from "./CustomText"
import BooleanCell from "./CustomFilterCell"
import { useHistory } from "react-router-dom"
import ActionMenu from "./ActionMenu"
import IconMenu from "./IconMenu"
import commonStyles from "../../styles/Pages/common/styles"
import moment from "moment"
import _ from "lodash"
import React, { useState } from "react"
import {
  Avatar,
  Button,
  Link,
  List,
  ListItem,
  Tooltip,
  Typography,
  Box,
  IconButton,
  Chip,
} from "@material-ui/core"
import { Map, VisibilityIcon, InfoMaterial, DoorCooler } from "@iconsGallery"
import styled from "styled-components"
import ShowCircleBasedOnProp from "./ShowCircleBasedOnProp"
import {
  CheckCircleIcon,
  Slash,
  AcknowledgeIconEnabled,
  AcknowledgeIconDisabled,
  ResolvedEnabled,
  ResolvedDisabled,
  CommentsEnabled,
  CommentsDisabled,
} from "../../IconsGallery/IconsGallery"
import RoleDropdown from "./RoleDropdown"
import ActionDropdown from "./ActionDropdown"
import MultiDropdown from "./MultiDropdown"
import StatusColorBased from "./StatusColorBased"
import SingleDropdown from "./SingleDropdown"
import AdjustmentReason from "./AdjustmentReason"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import * as Adm from "@adm"
import { ActionComments } from "@adm"
import { CommentsDialog } from "@adm"
import ExpiredFormat from "./ExpiredFormat"
import SaasView from "./SaasView"
import { useTranslation } from "react-i18next"
import ShowMore from "../AdmKit/ShowMore/ShowMore"
import GridNoRecordsText from "./GridNoRecordsText"
import MobileTabletCardList from "./MobileTabletCardList"
import editTurnstile from "../../pages/smartDeviceConfig/turnstile/editTurnstile"
const FORCE_ENABLED_MOBILER_CARD_UI = true
function formatDateUTC(isoString) {
  const date = new Date(isoString)
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]

  const day = String(date.getUTCDate()).padStart(2, "0")
  const month = months[date.getUTCMonth()]
  const year = date.getUTCFullYear()

  let hours = date.getUTCHours()
  const minutes = String(date.getUTCMinutes()).padStart(2, "0")
  const seconds = String(date.getUTCSeconds()).padStart(2, "0")
  const ampm = hours >= 12 ? "PM" : "AM"

  hours = hours % 12 || 12
  const hoursStr = String(hours).padStart(2, "0")

  return `${day}-${month}-${year} ${hoursStr}:${minutes}:${seconds} ${ampm}`
}

// console.log(formatDateUTC('2026-05-28T07:10:10.000Z'));

const useStyles = makeStyles((theme) => ({
  arrow: {
    "&:before": {
      border: "4px solid var(--primaryColor)",
    },
    color: "#fff",
    transform: "scale(4)",
  },
  tooltip: {
    top: "-5px",
    backgroundColor: "var(--primaryColor)",
    border: "0px solid #E6E8ED",
    color: "#fff",
  },
}))

const TemplateTableUIGrid = styled(Grid)`

.kdlc-tooltip {
  position: relative;
  display: inline-block;
}

.cls-kdc-sort-kit {
  margin-right:5px;
}
.cls-kdc-sort-kit img{
  width: 8px;
  height: 12px;
}
/* Tooltip text */
.kdlc-tooltip .kdlc-tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: var(--optionBgColor);
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
 
  position: absolute;
  z-index: 1;
  right: 22px;
  font-size: 11px;
  text-wrap: wrap;
  top: -6px;
  text-align: left;
  padding:3px;
   white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
   @supports (-webkit-line-clamp: 2) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  
}

.kdlc-tooltip:hover .kdlc-tooltiptext {
  visibility: visible;
}


.k-column-title {
  display:none !important;
}
  &.k-grid {
    background-color: #ffffff;
    box-shadow: 1px 2px 3px #0000002b;
  } 
  &.k-grid tr.k-state-selected > td{
    background-color: var(--lightColor);
    background-color: #e3e3e3;
  }
 .k-checkbox:checked{
    background-color: var(--primaryColor);
    border-Color: var(--primaryColor);
  }
  
  .k-grid-table {
    width: 100% !important
  }
  .k-grid-header table {
     width: 100% !important
  }
  .k-header {
    background: #f4f7fa;

    .k-link {
      color: #000000;
      font-weight: 500;
      padding: 15px 12px !important;
    }
  }
  .k-filter-row {
    background: #ffffff;

    .k-dropdown .k-dropdown-wrap {
      background: white;
      border: none;
    }
    .k-button {
      background: white;
      border: none;
    }

    .k-i-filter::before {
      color: #353535;
    }
    .k-textbox {
      border-top: none;
      border-left: none;
      border-right: none;
      background: transparent;
    }
  }

  &.k-grid td {
    border-bottom: 1px solid #e0e0e0;
  }
  .k-filter-row th {
    padding: 16px 8px;
  }
  .k-master-row,
  .k-pager-wrap {
    background: transparent !important;
    cursor: ${(props) => (props.cursor ? "pointer" : "")};
  }
    .k-grid tr.k-state-selected > td {
      color: #212529;
      background-color: var(--optionBgColor) !important;
    }

  .k-pager-numbers .k-link {
    color: var(--black);
  }
  .k-pager-numbers .k-link.k-state-selected {
    border-color: #dee2e6 !important ;
    color: var(--black) !important;
    background-color: var(--gray)!important;
  }

   .k-pager-numbers .k-link:hover {
    border-color: #dee2e6;
    color: var(--black) !important ;
    background-color: var(--gray) !important;
  }
  
  .k-checkbox {
    border: 2px solid #8c8c8c;
  }
  .bRDGfF {
    border-bottom: 1px solid #fefefe52;
  }

  .k-grid tbody td {
  }
  &.k-grid td {
    padding:${(props) =>
      props.BreadcrumbsValue2 === "Tax" ? "1rem 10px" : "0.4rem 10px"};
    border-style: solid;
    outline: 0;
    font-weight: inherit;
    // text-align:center;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.k-grid th {
    padding: 0.4rem 10px;
    border-style: solid;
    outline: 0;
    font-weight: inherit;
    text-align: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .k-grid-header thead tr:first-child th{ 
    background-color: var(--gray);
  }
  &.k-grid .k-filter-row th:empty {
    padding: 0 !important;
  }
  &.k-grid td,
  .k-grid .k-grid-content,
  .k-grid .k-grid-header-locked,
  .k-grid .k-grid-content-locked {
    border-color: transparent;
    border-bottom: 1px solid #e8e8e8;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.k-grid td.cls-log-view {
    overflow: unset !important;
    text-overflow: unset !important;
    white-space: unset !important;
  }
  .selected {
    margin-bottom: 10px,
    margin-left: 5px,
  }
.k-dropdown-operator {
    width: auto;
    display: none;
}
.k-icon-button, .k-button.k-button-icon {
    width: calc(0.2em + 0.2rem );
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.1rem;
}
.k-pager-info.k-label{
  display: block
}
.k-checkbox{
  margin-bottom: 6px;
  margin-left: 6px;
}
.k-pager-nav.k-link{
  color: var(--black);
}
.k-dropdown {
  background-color: var(--gray);
}
.k-grid-header .k-i-sort-asc-sm, .k-grid-header .k-i-sort-desc-sm{
  color: var(--black);
  place-self: flex-start;
  position: absolute;
  top: 40%;
  right: 5px;
}
.k-grid-header{
  padding: 0px
}
.k-grid-pager {
  display: ${(props) => (props.pagination ? "flex" : "none")} !important;
   ${""}
}

`

const getColor = ({ props }) => {
  return "pink"
}

const loadingPanel = (
  <div className="k-loading-mask">
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image"></div>
    <div className="k-loading-color"></div>
  </div>
)

const renderMaskContent = (props) => {
  let fieldValue = props?.dataItem[props?.field]
  if (typeof fieldValue === "number") {
    fieldValue = `${fieldValue}`
  }
  let splitString = fieldValue.length > 0 ? fieldValue.split("") : []

  let renderMask = () =>
    splitString.map((itm) => {
      return "*"
    })
  return <>{typeof fieldValue === "string" ? renderMask() : fieldValue}</>
}
const arrayToNested = (array) => {
  return _.reduce(
    array,
    (acc, val) => _.get(acc, `[${JSON.stringify(val)}]`),
    window
  )
}

const renderActionButtonKitSetup = (
  props,
  commonClasses,
  onSave,
  val,
  renderCustomUIActionButton = () => <span>Empty</span>
) => {
  return (
    <td id="test-kit-id" className="cls-test-kit-id-1">
      {renderCustomUIActionButton(props)}
    </td>
  )
  // return (
  //   <>
  //     {!_.isUndefined(props?.dataItem?.action?.name) &&
  //     !_.isEmpty(props?.dataItem?.action?.name) ? (
  //       <td id="test-kit-id" className="cls-test-kit-id-1">
  //         {props?.dataItem?.action?.name.length > 0 && (
  //           <Button
  //             variant="outlined"
  //             className={commonClasses.defaultOutlinedButton}
  //             onClick={() => {
  //               onSave(props)
  //             }}
  //             style={{
  //               marginBottom: "0px",
  //               marginTop: "0px",
  //               color: "white",
  //               minWidth: `150px`,
  //               backgroundColor: _.find(val.colorsArr, {
  //                 id: props?.dataItem?.action?.action_id,
  //               })?.colorCode,
  //             }}
  //           >
  //             {props?.dataItem?.action?.name}
  //           </Button>
  //         )}
  //       </td>
  //     ) : (
  //       <td id="test-kit-id" className="cls-test-kit-id-2">
  //         {props?.dataItem?.status?.name && (
  //           <Button
  //             variant="outlined"
  //             className={commonClasses.defaultOutlinedButton}
  //             disabled={true}
  //             style={{
  //               marginBottom: "0px",
  //               marginTop: "0px",
  //               color: "white",
  //               minWidth: `150px`,
  //               backgroundColor: "grey",
  //             }}
  //           >
  //             {props?.dataItem?.status?.name}
  //           </Button>
  //         )}
  //       </td>
  //     )}
  //   </>
  // )
}

const MaterialDataGrid = ({
  moduleType = "",
  getSelectRowItem = "",
  onUpdateSelectRowItem = () => "",
  isGridType = "1",
  forceHideEdit = false,
  renderCustomUIActionButton = () => "",
  isGrid = false,
  isAccordionEnable = false,
  isInlineEditAllowed = false,
  isInlineDeleteAllowed = true,
  gridState,
  columnData,
  pathProps,
  rowData,
  setRowData,
  setGridState,
  itemChange,
  setDefaultValue,
  headerSelectionChange,
  isLookup,
  selectionChange,
  onDiscard = () => {},
  onEdit = (e) => {},
  onDelete = () => {},
  onSave = () => {},
  onView = () => {},
  switchHandler,
  handleMultipleDropdown = () => {},
  pageData,
  actionMenu,
  isDisableForceNoActionMenu = false,
  additionalActions = () => {},
  reDirectButton,
  reDirectTo,
  number_of_items,
  pageChangeEvent,
  gridNoRecordsText = "No records found",
  loader,
  filterData,
  onRowClick = () => null,
  otherProps = {},
  menutype = "",
  historyPopup = true,
  buttonCount = 4,
  ShowCheckBox = true,
  checkBoxWidth = "50px",
  hideCheckboxAll = false,
  isOnRowClick = true,
  pageable = true,
  BreadcrumbsValue2 = "",
  cursor = false,
  pagination = true,
  deleteIcon = false,
  deleteIconHolder = false,
  tooltipColors = {},
  deleteIconTooltip = "",
  deleteDisabled = () => false,
  deleteTooltip = () => "Delete",
  editTooltip = () => "Edit",
  onDeleteDisabled = () => {},
  actionDropdown = false,
  handleSaveAction = () => {},
  handleSingleDropdownChange = () => {},
  isDisableViewIcon = false,
  actionEdit = true,
  actionDelete = true,
  nonApiDatastate = false,
  RoleDropdownList = [],
  setSelectedRoles = () => {},
  onConnectedChecked = () => "",
  customFilter = [],
  isDirectClick = false,
  actionCallBack = () => "",
  getAcknowledgedCommentsHandler = () => "",
  getResolvedCommentsHandler = () => "",
}) => {
  let classes = useStyles()
  let history = useHistory()
  const currentPathname = window?.location?.pathname || ""
  const isSmartDeviceConfigPath =
    currentPathname.includes("/autonomous-store/sdc") ||
    currentPathname.includes("/autonomous-store/device_config")
  const resolvedTooltipColors =
    tooltipColors && Object.keys(tooltipColors).length > 0
      ? tooltipColors
      : isSmartDeviceConfigPath
      ? { view: true, history: true, delete: true }
      : {}
  const { t } = useTranslation()

  // Mobile + tablet strictly use card UI; desktop keeps legacy Kendo grid

  const isMobileOrTablet = useMediaQuery("(max-width: 1024px)")
  const commonClasses = commonStyles()
  const gridRowsStyle = `tr.k-master-row k-alt {background:transparent;}`
  const [isMonitorComments, setIsMonitorComments] = useState(false)
  const [isComments, setIsComments] = useState(false)
  const [tableParams, setTableParams] = useState({})

  const acknowledgeClickHandler = (props, action) => {
    setIsMonitorComments(true)
    setTableParams((ps) => ({
      ...ps,
      eventId: props?.dataItem?.event_id,
      actionType: action,
    }))
  }

  const commentsClickHandler = () => {
    setIsComments(true)
  }

  const handleCommentsClose = () => {
    setIsMonitorComments(false)
  }

  const handleCommentsDialogClose = () => {
    setIsComments(false)
  }

  const dropDownFilterChange = (value, field) => {
    const newFilterObj = {
      logic: "and",
      filters: [],
    }
    const newGridState = { ...gridState }
    if (newGridState.dataState.filter === null) {
      newGridState.dataState.filter = newFilterObj
    }
    const newFilter = [
      {
        field: field,
        operator: "eq",
        value: value,
      },
    ]
    const filterIndex =
      newGridState.dataState &&
      newGridState.dataState.filter &&
      newGridState.dataState.filter.filters &&
      newGridState.dataState.filter.filters.findIndex(
        (filter) => filter.field === field
      )
    if (value !== "All") {
      filterIndex !== -1
        ? newGridState.dataState.filter.filters.length !== 0
          ? newGridState.dataState.filter.filters.splice(
              filterIndex,
              1,
              newFilter[0]
            )
          : (newGridState.filter.filters = newFilter[0])
        : newGridState.dataState.filter
        ? newGridState.dataState.filter.filters.push(newFilter[0])
        : (newGridState.dataState.filter["filters"] = newFilter)
    } else {
      newGridState.dataState.filter.filters.splice(filterIndex, 1)
    }
    setGridState((c) => ({ dataState: { ...c.dataState, skip: 0 } }))
  }

  const onClearButtonClick = (field) => {
    const newGridState = { ...gridState }
    const filterIndex =
      newGridState.dataState &&
      newGridState.dataState.filter &&
      newGridState.dataState.filter.filters.findIndex(
        (filter) => filter.field === field
      )
    newGridState.dataState.filter.filters.splice(filterIndex, 1)
    setGridState((c) => ({ dataState: { ...c.dataState, skip: 0 } }))
  }

  const handleKeyPress = (e) => {
    if (e.which === 32) {
      e.preventDefault()
    }
  }

  const gridWidth = 900

  const setPercentage = (percentage) => {
    return Math.round(gridWidth / 100) * percentage
  }

  const _export = React.useRef(null)
  const excelExport = () => {
    if (_export.current !== null) {
      _export.current.save(
        rowData.data,
        _.filter(columnData, _.matches({ show: true }))
      )
    }
  }

  if (FORCE_ENABLED_MOBILER_CARD_UI) {
    if (isMobileOrTablet) {
      return (
        <>
          {loader && loadingPanel}
          <ExcelExport ref={_export} />
          <MobileTabletCardList
            columnData={columnData}
            rowData={rowData}
            gridState={gridState}
            nonApiDatastate={nonApiDatastate}
            number_of_items={number_of_items}
            setGridState={setGridState}
            pageable={pageable}
            pagination={pagination}
            ShowCheckBox={ShowCheckBox}
            isInlineEditAllowed={isInlineEditAllowed}
            selectionChange={selectionChange}
            onRowClick={onRowClick}
            isOnRowClick={isOnRowClick}
            hideCheckboxAll={hideCheckboxAll}
            isDirectClick={isDirectClick}
            onEdit={onEdit}
            onDelete={onDelete}
            onDiscard={onDiscard}
            onSave={onSave}
            onView={onView}
            isLookup={isLookup}
            isDisableForceNoActionMenu={isDisableForceNoActionMenu}
            actionMenu={actionMenu}
            actionDropdown={actionDropdown}
            handleSaveAction={handleSaveAction}
            additionalActions={additionalActions}
            forceHideEdit={forceHideEdit}
            deleteIcon={deleteIcon}
            deleteIconHolder={deleteIconHolder}
            tooltipColors={resolvedTooltipColors}
            deleteDisabled={deleteDisabled}
            deleteTooltip={deleteTooltip}
            onDeleteDisabled={onDeleteDisabled}
            menutype={menutype}
            historyPopup={historyPopup}
            isDisableViewIcon={isDisableViewIcon}
            actionEdit={actionEdit}
            actionDelete={actionDelete}
            gridNoRecordsText={gridNoRecordsText}
            getSelectRowItem={getSelectRowItem}
            onUpdateSelectRowItem={onUpdateSelectRowItem}
          />
        </>
      )
    }
  }

  const renderStoreInfoItemKit = (innerProps) => {
    const [_itmData = {}] = rowData?.data?.filter(
      (itm) => itm?.locationId === innerProps?.dataItem?.locationId
    )

    const stats = [
      {
        key: "available",
        label: "Available Systems",
        count: _itmData?.available_device || 0,
        color: "#1565EF",
      },
      {
        key: "issues",
        label: "Systems with Issues",
        count: _itmData?.store_with_issue || 0,
        color: "#E02B2B",
      },
    ]

    return (
      <div
        key={JSON.stringify(_itmData)}
        style={{
          display: "flex",
          alignItems: "stretch",
          border: "0px solid #E4E4E4",
          borderRadius: 8,
          backgroundColor: "#FFFFFF",
          overflow: "hidden",
          width: "100%",
          height: "100%",
          margin: "auto",
        }}
      >
        {stats.map(({ key, label, count, color }, index) => (
          <div
            key={key}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              // padding: "14px 40px",
              width: "50%",
              borderLeft: index === 0 ? "none" : "1px solid #E4E4E4",
              textAlign: "center",
            }}
          >
            <span
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: "#2B2B2B",
                whiteSpace: "nowrap",
              }}
            >
              {label}
              {_itmData?.isLiveKit && (
                <span
                  style={{
                    fontSize: 10,
                    fontWeight: 600,
                    color: "green",
                    whiteSpace: "nowrap",
                    marginLeft: 5,
                  }}
                >
                  {"(LIVE)"}
                </span>
              )}
            </span>
            <span
              style={{
                fontSize: 20,
                fontWeight: 700,
                color,
                marginTop: 6,
                lineHeight: 1,
              }}
            >
              {count}
            </span>
          </div>
        ))}
      </div>
    )
  }
  const renderStoreInfoItem = (innerProps) => {
    return (
      <div
        className="cls-storeInfoItem-wrapper"
        style={{ borderTop: "1px solid #E4E4E4" }}
      >
        {renderStoreInfoItemKit(innerProps)}
      </div>
    )
  }

  return (
    <>
      {loader && loadingPanel}
      <style type="text/css">{gridRowsStyle}</style>

      <ExcelExport ref={_export} />
      <TemplateTableUIGrid
        pageable={
          pageable
            ? { buttonCount: buttonCount, pageSizes: [50, 100, 150, 200] }
            : false
        }
        filterable
        sortable
        style={{
          height: "auto",
          width: "100% !important",
          stripeRows: "false",
        }}
        data={
          nonApiDatastate
            ? process(rowData?.data, gridState?.dataState)
            : rowData?.data
        }
        {...gridState.dataState}
        onDataStateChange={(e) => {
          setGridState({ dataState: e.dataState })
        }}
        onSortChange={({ sort }) => {
          setGridState((c) => ({
            dataState: { ...c.dataState, sort, skip: 0 },
          }))
        }}
        editField="inEdit"
        selectedField="selected"
        onSelectionChange={(event) => selectionChange(event)}
        onHeaderSelectionChange={(event) => headerSelectionChange(event)}
        onItemChange={(event) => {
          itemChange(event)
        }}
        total={number_of_items}
        className={`cls-moduleType-${
          moduleType || "common"
        } cls-material-grid-view-type-${isGridType} ${
          hideCheckboxAll ? commonClasses.hideCheckboxAll : ""
        } ${isGrid ? "cls-material-grid-view-ui" : ""}`}
        GridLinesVisibility
        onRowClick={(event) => {
          hideCheckboxAll && selectionChange(event)
          isOnRowClick && _.isFunction(onRowClick) && onRowClick(event)

          if (isDirectClick) {
            onEdit(event)
          }
        }}
        {...otherProps}
        BreadcrumbsValue2={BreadcrumbsValue2}
        cursor={cursor}
        pagination={pagination}
      >
        <GridNoRecords>
          {gridNoRecordsText && (
            <GridNoRecordsText gridNoRecordsText={gridNoRecordsText} />
          )}
        </GridNoRecords>
        {ShowCheckBox && isInlineEditAllowed === true && (
          <Column
            field="selected"
            width={checkBoxWidth}
            filterable={false}
            headerSelectionValue={
              !_.isEmpty(_.get(rowData, "data", [])) &&
              _.filter(_.get(rowData, "data", []), (x) => _.get(x, "selected"))
                .length === _.get(rowData, "data", []).length
            }
          />
        )}
        {columnData &&
          columnData.map((val, index) => {
            const {
              connect = false,
              isPermissionModeBTN = false,
              logType = false,
              isDateFormat = false,
              isSaasView = false,
              isDateForceFormat = false,
              isDirectDateFormat = false,
              isExpiresFormat = false,
              paragraphType = false,
              enableTextMask = false,
              isConnected = false,
              imageContent = false,
              imageWithText = false,
              disableEvent = false,
              isFieldLogo = false,
              iconView = [],
              infoText = "",
              isDoorCooler = false,
            } = val || {}

            return (
              val.show && (
                <Column
                  headerCell={(props) => {
                    let sortkit =
                      "data:image/png;base64,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"
                    let desc =
                      "data:image/png;base64,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"
                    let asc =
                      "data:image/png;base64,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"
                    const { columnMenuWrapperProps = {} } = props || {}
                    const { sort = [], sortable = false } =
                      columnMenuWrapperProps || {}
                    const [_Sort = {}] = sort || {}
                    const { dir = "", field = "" } = _Sort || {}
                    return (
                      <GridHeaderCell
                        {...props}
                        className="cls-custom-header-kendo-kit"
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          {sortable && (
                            <>
                              {dir.length > 0 ? (
                                <>
                                  {dir.length && field === val?.field ? (
                                    <span
                                      className={`cls-kdc-sort-kit cls-kdc-icon-${dir}`}
                                    >
                                      <img
                                        alt={dir}
                                        src={dir === "asc" ? asc : desc}
                                      />
                                    </span>
                                  ) : (
                                    <span
                                      className={`cls-kdc-sort-kit cls-kdc-icon-sort`}
                                    >
                                      <img alt={"sort"} src={sortkit} />
                                    </span>
                                  )}
                                </>
                              ) : (
                                <span
                                  className={`cls-kdc-sort-kit cls-kdc-icon-sort`}
                                >
                                  <img alt={"sort"} src={sortkit} />
                                </span>
                              )}
                            </>
                          )}
                          <div>{t(val.title)}</div>

                          {infoText?.length ? (
                            <div style={{ marginLeft: 20 }}>
                              <div class="kdlc-tooltip">
                                <InfoMaterial />
                                <span class="kdlc-tooltiptext">{infoText}</span>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </GridHeaderCell>
                    )
                  }}
                  key={index}
                  field={val.field && val.field}
                  editable={val.editable && val.editable}
                  sortable={val.sortable && val.sortable}
                  editor={val.editor && val.editor}
                  filterable={val.filter && val.filter}
                  filter={val.filterType && val.filterType}
                  onKeyPress={(e) => handleKeyPress(e)}
                  filterCell={
                    val.filterType === "boolean" && val.customFilter === true
                      ? (props) => (
                          <BooleanCell
                            data={val.filterData && val.filterData}
                            onKeyPress={(e) => handleKeyPress(e)}
                            value={
                              gridState.dataState.filter
                                ? gridState.dataState.filter.filters[
                                    gridState.dataState.filter.filters.findIndex(
                                      (filter) => filter.field === val.field
                                    )
                                  ]
                                : { value: "All" }
                            }
                            dropdownChange={dropDownFilterChange}
                            onClearButtonClick={onClearButtonClick}
                            field={val.field}
                          />
                        )
                      : val.filterType === "custom" && val.customFilter === true
                      ? (props) => (
                          <BooleanCell
                            data={customFilter}
                            onKeyPress={(e) => handleKeyPress(e)}
                            value={
                              gridState.dataState.filter
                                ? gridState.dataState.filter.filters[
                                    gridState.dataState.filter.filters.findIndex(
                                      (filter) => filter.field === val.field
                                    )
                                  ]
                                : { value: "All" }
                            }
                            dropdownChange={dropDownFilterChange}
                            onClearButtonClick={onClearButtonClick}
                            field={val.field}
                          />
                        )
                      : val.filterCell
                      ? val.filterCell
                      : null
                  }
                  width={setPercentage(val.min_width)}
                  cell={
                    val.cell && val.switchCell
                      ? (props) => (
                          <>
                            {moduleType === "store" &&
                              renderStoreInfoItem(props)}
                            <SwitchCell
                              isGrid={isGrid}
                              dataItem={props.dataItem}
                              value={props.dataItem[props.field]}
                              renderBox={props.dataItem[props.field]}
                              filterData={val.filterData}
                              onChange={(event) => {
                                switchHandler(event, props)
                              }}
                              showIconInSwitchCellDisplay={
                                val.showIconInSwitchCellDisplay
                              }
                            />
                          </>
                        )
                      : enableTextMask
                      ? (props) => (
                          <td id="test-kit-id">
                            <Typography>
                              {renderMaskContent({
                                ...props,
                              })}
                            </Typography>
                          </td>
                        )
                      : val.cell && val.SwitchCellDisabled
                      ? (props) => (
                          <>
                            <SwitchCellDisabled
                              dataItem={props.dataItem}
                              value={props.dataItem[props.field]}
                              renderBox={props.dataItem[props.field]}
                              filterData={val.filterData}
                              onChange={(event) => {
                                switchHandler(event, props)
                              }}
                              showIconInSwitchCellDisplay={
                                val.showIconInSwitchCellDisplay
                              }
                            />
                          </>
                        )
                      : connect === true
                      ? (props) => {
                          const { dataItem = {} } = props || {}
                          const { isConnected = false, isLocked = false } =
                            dataItem || {}

                          return (
                            <td
                              id="test-kit-id"
                              className={
                                isConnected
                                  ? `cls-selected-isconnected cls-checkbox-connect-kit`
                                  : "cls-checkbox-connect-kit"
                              }
                            >
                              <div>
                                <span>
                                  <Checkbox
                                    disabled={isLocked}
                                    onClick={(event) => {
                                      onConnectedChecked({
                                        isConnected: !isConnected,
                                        currentItem: props,
                                      })
                                    }}
                                    key={isConnected}
                                    defaultChecked={isConnected}
                                  />
                                </span>
                              </div>
                            </td>
                          )
                        }
                      : isDateFormat
                      ? (props) => (
                          <td id="id-is-date-Format">
                            <div
                              style={{
                                fontSize: 14,
                                wordWrap: " break-word",
                                width: 200,
                                textWrap: "initial",
                              }}
                            >
                              <span style={{ textTransform: "capitalize" }}>
                                {props?.field?.replaceAll("_", " ") + ": "}
                              </span>

                              {moment(props?.dataItem[props?.field]).format(
                                "DD-MMM-YYYY"
                              )}
                            </div>
                          </td>
                        )
                      : isDoorCooler
                      ? (props) => (
                          <td id="id-is-door-cooler">
                            <DoorCooler
                              // onUpdateSelectRowItem={onUpdateSelectRowItem}
                              // getSelectRowItem={getSelectRowItem}
                              onClick={() => {
                                _.isFunction(onRowClick) &&
                                  onRowClick({ dataItem: props?.dataItem })
                              }}
                              dataItem={props?.dataItem}
                              field={val.field}
                              columnData={columnData}
                              // value={props?.dataItem[props?.field]}
                            />
                          </td>
                        )
                      : isSaasView
                      ? (props) => (
                          <td id="id-is-saas-view">
                            <SaasView
                              onUpdateSelectRowItem={onUpdateSelectRowItem}
                              getSelectRowItem={getSelectRowItem}
                              dataItem={props?.dataItem}
                              value={props?.dataItem[props?.field]}
                            />
                          </td>
                        )
                      : isDateForceFormat
                      ? (props) => (
                          <td id="id-is-date-Format">
                            {isDirectDateFormat ? (
                              <div>
                                {formatDateUTC(props?.dataItem[props?.field])}
                              </div>
                            ) : (
                              <div>
                                {moment(
                                  props?.dataItem[props?.field] || ""
                                ).format("DD-MMM-YYYY hh:mm:ss A")}
                              </div>
                            )}
                            {/* <div>{}</div> */}
                          </td>
                        )
                      : isExpiresFormat
                      ? (props) => (
                          <td id="id-is-Expires-Format">
                            <ExpiredFormat
                              dataItem={props?.dataItem}
                              value={props?.dataItem[props?.field]}
                            />
                          </td>
                        )
                      : val.arrValues
                      ? (props) => (
                          <>
                            <RoleDropdown
                              field={props.field}
                              dataItem={props.dataItem}
                              value={props.dataItem[props.field]}
                              bgColor={val.arrbgColor}
                              handleChange={(event) => {
                                handleMultipleDropdown(event, props)
                              }}
                              list={RoleDropdownList || []}
                              setSelectedRoles={setSelectedRoles}
                            />
                          </>
                        )
                      : val.checkbox
                      ? (props) => (
                          <CheckboxCell
                            dataItem={props.dataItem}
                            value={props.dataItem[props.field]}
                            renderText={props.dataItem[props.field]}
                            onClick={(event) => {
                              setDefaultValue(event, props)
                            }}
                          />
                        )
                      : val.customText
                      ? (props) => (
                          <CustomText
                            dataItem={props.dataItem}
                            value={props.dataItem[props.field]}
                            renderText={props.dataItem[props.field]}
                            filterData={val.filterData}
                            onClick={(event) => {
                              setDefaultValue(event, props)
                            }}
                          />
                        )
                      : val.showCircleColor
                      ? (props) => <ShowCircleBasedOnProp showColor={"red"} />
                      : val.renderDate
                      ? (props) => (
                          <td id="test-kit-id">
                            <p>
                              {moment(props.dataItem[props.field]).format(
                                "MM/DD/YYYY"
                              )}
                            </p>
                          </td>
                        )
                      : val.button
                      ? (props) => {
                          let isPermissionAvailable =
                            props.dataItem[props.field] === undefined
                              ? "ADD"
                              : "CHANGE"
                          const isDefaultKit =
                            typeof props.dataItem.isRowEditable !== "undefined"
                              ? props.dataItem.isRowEditable
                              : isInlineEditAllowed

                          return (
                            <td id="test-kit-id">
                              {isPermissionModeBTN ? (
                                props.dataItem[props.field] === "-" ||
                                props.dataItem.inEdit ? (
                                  "-"
                                ) : props.dataItem[props.field] ? (
                                  <IconButton
                                    variant="outlined"
                                    onClick={() => onView(props)}
                                  >
                                    <VisibilityIcon
                                      style={{
                                        fill: "var(--primaryColor)",
                                      }}
                                    />
                                  </IconButton>
                                ) : (
                                  <>
                                    <IconButton
                                      variant="outlined"
                                      onClick={() => onView(props)}
                                    >
                                      <Box className={commonClasses.enabledBox}>
                                        Set
                                      </Box>
                                    </IconButton>
                                  </>
                                )
                              ) : (
                                <Button
                                  variant="outlined"
                                  className={
                                    commonClasses.defaultOutlinedButton
                                  }
                                  onClick={() => {
                                    reDirectTo(props.dataItem)
                                  }}
                                  style={{
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                    color: "#1565C0",
                                  }}
                                >
                                  <Map size="15" /> &ensp;List
                                </Button>
                              )}
                            </td>
                          )
                        }
                      : val.text
                      ? (props) => (
                          <td id="test-kit-id">
                            {props.dataItem[props.field] ? "Yes" : "No"}
                          </td>
                        )
                      : val.bgLabel
                      ? (props) => {
                          const textValueKit = props?.dataItem[props?.field]
                          return (
                            <td id="test-kit-id">
                              <Typography
                                style={{
                                  backgroundColor:
                                    textValueKit === "HIGH"
                                      ? val.bgColor
                                      : textValueKit === "MEDIUM"
                                      ? "Orange"
                                      : textValueKit === "LOW"
                                      ? "#b0c619"
                                      : "blue",
                                  width: "fit-content",
                                  padding: "3px 5px",
                                  color: "#ffffff",
                                  borderRadius: "4px",
                                }}
                              >
                                {textValueKit}
                              </Typography>
                            </td>
                          )
                        }
                      : val.toolTip
                      ? logType
                        ? (props) => (
                            <td id="test-kit-id">
                              <ShowMore
                                defaultValue={props.dataItem[props.field]}
                              />
                            </td>
                          )
                        : paragraphType
                        ? (props) => {
                            const checkingObject = props?.field?.split(".")
                            const convertedArray = checkingObject
                              .map((item) => `['${item}']`)
                              .join("")
                            let combinedValue =
                              props?.field?.split(".")?.length > 1
                                ? props?.dataItem[checkingObject[0]][
                                    checkingObject[1]
                                  ]
                                : props?.dataItem[props?.field]

                            return (
                              <td id="test-kit-id">
                                <Adm.ContentDescription
                                  defaultValue={combinedValue}
                                />
                              </td>
                            )
                          }
                        : (props) => (
                            <Tooltip title={props.dataItem[props.field]}>
                              <td id="test-kit-id">
                                {props.dataItem[props.field]}
                              </td>
                            </Tooltip>
                          )
                      : val.statusColorBased
                      ? (props) => (
                          <StatusColorBased
                            {...props}
                            title={props.dataItem[props.field]}
                            colorsArr={val.colorsArr}
                            fieldMap={val.fieldMap}
                            subfieldMap={val.subfieldMap}
                            isCustom={val.isCustom}
                          />
                        )
                      : val.singledropdown
                      ? (props) => (
                          <SingleDropdown
                            {...props}
                            dataItem={props.dataItem}
                            list={val.dropdownValues}
                            value={props.dataItem[props.field]}
                            handleChange={(e) =>
                              handleSingleDropdownChange(e, {
                                ...props,
                              })
                            }
                          />
                        )
                      : val.adjustmentReason
                      ? (props) => (
                          <AdjustmentReason
                            {...props}
                            dataItem={props.dataItem}
                            list={val.dropdownValues}
                            value={props.dataItem[props.field]}
                            handleChange={(e) =>
                              handleSingleDropdownChange(e, {
                                ...props,
                              })
                            }
                          />
                        )
                      : val.verified
                      ? (props) => {
                          return (
                            <td
                              id="test-kit-id"
                              style={{
                                padding: "10px",
                              }}
                            >
                              {props.dataItem[props.field] &&
                              (val.options
                                ? val.options.includes(
                                    props.dataItem[props.field]
                                  )
                                : true) ? (
                                <Tooltip
                                  disableHoverListener={!val.filterData?.length}
                                  title={
                                    val.filterData &&
                                    val.filterData.find(
                                      (item) => item.value === true
                                    )?.status
                                  }
                                  placement="top"
                                >
                                  <span>
                                    <CheckCircleIcon
                                      style={{
                                        width: "20px",
                                        color: "#4CAF50",
                                      }}
                                    />
                                  </span>
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  disableHoverListener={!val.filterData?.length}
                                  title={
                                    val.filterData &&
                                    val.filterData.find(
                                      (item) => item.value === false
                                    )?.status
                                  }
                                  placement="top"
                                >
                                  <span>
                                    <Slash
                                      style={{
                                        width: "20px",
                                        color: "gray",
                                      }}
                                    />
                                  </span>
                                </Tooltip>
                              )}
                            </td>
                          )
                        }
                      : val.isSubfield
                      ? (props) => (
                          <td
                            id="test-kit-id"
                            style={{
                              padding: "15px 10px",
                            }}
                          >
                            <Typography
                              style={{
                                fontSize: "14px",
                              }}
                            >
                              {props.dataItem[props.field]}
                            </Typography>
                            <Typography
                              style={{
                                fontSize: "12px",
                                color: "gray",
                              }}
                            >
                              {props.dataItem[val.subfield]}
                            </Typography>
                          </td>
                        )
                      : val.image
                      ? (props) => {
                          return (
                            <td
                              id="test-kit-id"
                              style={{
                                display: "flex",
                                padding: "15px 10px",
                              }}
                            >
                              <Avatar
                                src={
                                  isFieldLogo
                                    ? props?.dataItem[val.subfield]
                                    : props?.dataItem[props?.field]
                                }
                                style={{
                                  backgroundColor: "#f3f7fc",
                                  color: "var(--primaryColor)",
                                  height: "45px",
                                  width: "45px",
                                  fontSize: "14px",
                                  border: "1px solid #bcbcbc",
                                }}
                              >
                                {_.upperCase(
                                  props?.dataItem[val.subfield]?.charAt(0)
                                )}
                                {val.secondField &&
                                  _.upperCase(
                                    props?.dataItem[val.secondField]?.charAt(0)
                                  )}
                              </Avatar>
                              <Typography
                                style={{
                                  display: "flex",
                                  paddingLeft: "30px",
                                  paddingTop: "10px",
                                }}
                              >
                                {isFieldLogo
                                  ? `${props?.dataItem[val.field]} ${
                                      val.secondField &&
                                      props?.dataItem[val.secondField]
                                    }`
                                  : `${props?.dataItem[val.subfield]} ${
                                      val.secondField &&
                                      props?.dataItem[val.secondField]
                                    }`}
                              </Typography>
                            </td>
                          )
                        }
                      : val.feildCircle
                      ? (props) => (
                          <td id="test-kit-id">
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                              }}
                            >
                              {_.isArray(props.dataItem[val.iteratorName]) ? (
                                props.dataItem[val.iteratorName].map(
                                  (val, index) => {
                                    return (
                                      <div
                                        className={
                                          commonClasses.feildCircleStyle
                                        }
                                        key={index}
                                      >
                                        {val?.name === undefined
                                          ? val
                                          : val?.name}
                                      </div>
                                    )
                                  }
                                )
                              ) : (
                                <div
                                  className={
                                    _.isEmpty(props.dataItem[val.iteratorName])
                                      ? ""
                                      : commonClasses.feildCircleStyle
                                  }
                                >
                                  {props.dataItem[val.iteratorName]}
                                </div>
                              )}
                            </div>
                          </td>
                        )
                      : val.circleStatus
                      ? (props) => {
                          return (
                            <td id="test-kit-id">
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                }}
                              >
                                {val.filterData?.some(
                                  (f) =>
                                    props.dataItem[val?.field] === f.value &&
                                    f.key
                                ) ? (
                                  <div
                                    className={commonClasses.circleActive}
                                    style={{
                                      marginTop: "2px",
                                    }}
                                  ></div>
                                ) : (
                                  <div
                                    className={commonClasses.circleInactive}
                                  ></div>
                                )}
                              </div>
                            </td>
                          )
                        }
                      : val.list
                      ? (props) => (
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                            }}
                          >
                            {_.isArray(props.dataItem[val.field]) ? (
                              props.dataItem[val.field].map((val, index) => {
                                return (
                                  <div
                                    className={commonClasses.feildCircleStyle}
                                    key={index}
                                  >
                                    {val?.name === undefined ? val : val?.name}
                                  </div>
                                )
                              })
                            ) : (
                              <div
                                className={
                                  _.isEmpty(props.dataItem[val.field])
                                    ? ""
                                    : commonClasses.feildCircleStyle
                                }
                              >
                                {props.dataItem[val.field]}
                              </div>
                            )}
                          </div>
                        )
                      : val.renderDateTime
                      ? (props) => (
                          <td id="test-kit-id">
                            <p>
                              {moment(props.dataItem[props.field]).format(
                                "MM/DD/YYYY HH:MM:SS A"
                              )}
                            </p>
                          </td>
                        )
                      : val.renderImageList
                      ? (props) => (
                          <td id="test-kit-id">
                            {
                              <Link
                                target="_blank"
                                href={props.dataItem[props.field][0]}
                              >
                                Click to see image
                              </Link>
                            }
                          </td>
                        )
                      : val.isNumber
                      ? (props) => (
                          <td
                            id="test-kit-id"
                            className={commonClasses.numberFormat}
                          >
                            {props.dataItem[props.field]}
                          </td>
                        )
                      : val.hyphenDisplay
                      ? (props) => {
                          return (
                            <>
                              {!_.isUndefined(
                                _.get(props.dataItem, props.field)
                              ) ? (
                                <>
                                  <td id="test-kit-id">
                                    <Typography>
                                      {_.get(props.dataItem, props.field)}
                                    </Typography>
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td
                                    id="test-kit-id"
                                    style={{
                                      textAlign: "center",
                                    }}
                                  >
                                    <Typography>{"-"}</Typography>
                                  </td>
                                </>
                              )}
                            </>
                          )
                        }
                      : iconView && iconView.length > 0
                      ? (props) => {
                          let keyValue = props?.dataItem[props?.field]
                          let getIconView = iconView.filter(
                            (itm) => itm?.type === keyValue
                          )
                          const [_getIconViewOne = {}] = getIconView || []
                          const { icon: DynamicIcon = () => "-" } =
                            _getIconViewOne || {}
                          return (
                            <td id="test-kit-id">
                              <DynamicIcon />
                            </td>
                          )
                        }
                      : imageWithText
                      ? (props) => {
                          return (
                            <td id="test-kit-id">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (disableEvent === false) {
                                    onEdit(props)
                                  }
                                }}
                              >
                                <div
                                  style={{
                                    overflow: "hidden",
                                    width: 50,
                                    height: 50,
                                    marginRight: 8,
                                    background: "#f1f1f1",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  <img
                                    style={{
                                      width: "auto",
                                      height: 45,
                                      margin: "auto",
                                      display: "flex",
                                      padding: 3,
                                    }}
                                    src={
                                      props?.dataItem[val?.imageFieldName] ||
                                      "/static/img/noproducts.png"
                                    }
                                    alt={props?.dataItem[props?.field]}
                                  />
                                </div>
                                <div
                                  className="cls-imageFieldName-txt"
                                  style={{
                                    textWrap: "wrap",
                                    width: "calc(100% - 58px)",
                                    fontSize: 14,
                                    fontWeight: 500,
                                  }}
                                >
                                  {props?.dataItem[props?.field]}
                                </div>
                              </div>
                            </td>
                          )
                        }
                      : imageContent
                      ? (props) => {
                          const omit = [
                            "_id",
                            "is_active",
                            "item_images",
                            "isConnected",
                            "storage_unit_inventory_on_hand",
                            "storage_unit_minimum_threshold",
                            "storage_unit_reorder_quantity",
                            "product_image_url",
                            "storage_unit_is_active",
                            "storage_unit_id",
                            "company_id",
                            "company_name",
                            "product_item_id",
                          ]

                          let tooltipDataItemKit = Object.keys(props?.dataItem)
                          tooltipDataItemKit = tooltipDataItemKit.filter(
                            function (el) {
                              return !omit.includes(el)
                            }
                          )

                          return (
                            <td id="test-kit-id">
                              <div
                                className="cls-img-wrapper-kit-connect"
                                style={{
                                  width: "auto",
                                  height: "auto",
                                  margin: "auto",
                                  display: "flex",
                                  minWidth: 80,
                                  minHeight: 80,
                                  maxWidth: 80,
                                  maxHeight: 80,
                                  borderRadius: 5,
                                }}
                              >
                                <Tooltip
                                  arrow
                                  classes={{
                                    arrow: classes.arrow,
                                    tooltip: classes.tooltip,
                                  }}
                                  style={{
                                    background: "pink",
                                  }}
                                  placement="bottom"
                                  title={
                                    <Box
                                      style={{
                                        width: 640,
                                        minHeight: 100,
                                      }}
                                    >
                                      <Box
                                        style={{
                                          padding: 10,
                                        }}
                                      >
                                        {tooltipDataItemKit.map((innerItem) => {
                                          return (
                                            <Box
                                              style={{
                                                display: "flex",
                                                marginBottom: 10,
                                              }}
                                            >
                                              <Box
                                                style={{
                                                  fontSize: 14,
                                                  marginRight: 5,
                                                }}
                                              >{`${
                                                innerItem.includes("stock_code")
                                                  ? "SKU"
                                                  : innerItem.includes(
                                                      "product_title"
                                                    )
                                                  ? "Product Name"
                                                  : innerItem.includes(
                                                      "product_barcode_value"
                                                    )
                                                  ? "Barcode Value"
                                                  : innerItem
                                              }: `}</Box>
                                              <Box
                                                style={{
                                                  fontSize: 14,
                                                  display: "flex",
                                                  wordWrap: "break-word",
                                                  width: "180px",
                                                  overflow: "hidden",
                                                }}
                                              >
                                                {props?.dataItem[innerItem]}
                                              </Box>
                                            </Box>
                                          )
                                        })}
                                      </Box>
                                    </Box>
                                  }
                                >
                                  <img
                                    style={{
                                      cursor: "pointer",
                                      width: "auto",
                                      height: "auto",
                                      margin: "auto",
                                      display: "flex",
                                      minWidth: 70,
                                      minHeight: 70,
                                      maxWidth: 70,
                                      maxHeight: 70,
                                      borderRadius: 5,
                                    }}
                                    src={props?.dataItem[props?.field]}
                                    alt={props?.dataItem[props?.field]}
                                  />
                                </Tooltip>
                              </div>
                            </td>
                          )
                        }
                      : val.renderFilterCell
                      ? (props) => (
                          <td id="test-kit-id">
                            <Typography>
                              {props.dataItem.inEdit
                                ? "-"
                                : val.filterData?.find(
                                    (f) =>
                                      f.value?.toString() ===
                                      props?.dataItem[props?.field]?.toString()
                                  )?.tab}
                            </Typography>
                          </td>
                        )
                      : val.adjustmentType
                      ? (props) => (
                          <td id="test-kit-id">
                            <Typography>
                              {props?.dataItem[props?.field]?.toString() ===
                              "true"
                                ? "Increment"
                                : "Decrement"}
                            </Typography>
                          </td>
                        )
                      : val.actionButton
                      ? (props) => {
                          return (
                            <>
                              {renderActionButtonKitSetup(
                                props,
                                commonClasses,
                                onSave,
                                val,
                                renderCustomUIActionButton
                              )}
                            </>
                          )
                        }
                      : val.actionComments
                      ? (props) => {
                          const statusName = props?.dataItem?.status?.name
                          const isAcknowledgeEnabled = statusName === "New"
                          const isResolvedEnabled =
                            statusName === "Acknowledged"
                          return (
                            <div
                              style={{
                                paddingTop: "30px",
                                paddingLeft: "20px",
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <Button
                                onClick={() =>
                                  acknowledgeClickHandler(props, 1)
                                }
                                disabled={!isAcknowledgeEnabled}
                              >
                                {isAcknowledgeEnabled ? (
                                  <Tooltip title="Acknowledge" arrow>
                                    <AcknowledgeIconEnabled />
                                  </Tooltip>
                                ) : (
                                  <AcknowledgeIconDisabled />
                                )}
                              </Button>
                              <Button
                                onClick={() =>
                                  acknowledgeClickHandler(props, 2)
                                }
                                disabled={!isResolvedEnabled}
                              >
                                {isResolvedEnabled ? (
                                  <ResolvedEnabled />
                                ) : (
                                  <ResolvedDisabled />
                                )}
                              </Button>
                              <Button
                                onClick={commentsClickHandler}
                                handleCommentsDialogClose={
                                  handleCommentsDialogClose
                                }
                              >
                                <CommentsEnabled />
                              </Button>
                              {/* <ActionComments
                                open={isMonitorComments}
                                handleCommentsClose={handleCommentsClose}
                                submitButtonLabel={
                                  statusName === "New"
                                    ? "Move to Acknowledge"
                                    : "Resolved"
                                }
                                onSubmit={(comment) => {
                                  actionCallBack({ comment, ...tableParams })
                                }}
                              /> */}

                              {/* <CommentsDialog
                                isComments={isComments}
                                handleCommentsDialogClose={
                                  handleCommentsDialogClose
                                }
                                acknowledgedComment={
                                  props?.dataItem?.acknowledged_comments
                                }
                                resolvedComment={
                                  props?.dataItem?.resolved_comments
                                }
                              /> */}
                            </div>
                          )
                        }
                      : null
                  }
                />
              )
            )
          })}

        {!isLookup ? (
          isDisableForceNoActionMenu ? (
            <></>
          ) : actionMenu ? (
            actionDropdown ? (
              <Column
                className="cls-action-button-col"
                title="Actions"
                width={setPercentage(20)}
                resizable={true}
                filterable={false}
                sortable={false}
                cell={(props) => (
                  <ActionDropdown
                    props={props}
                    dataItem={props.dataItem}
                    value={props.dataItem[props.field]}
                    handleChange={(event) => handleSaveAction(event, props)}
                  />
                )}
              />
            ) : (
              <Column
                className="cls-action-button-col"
                title="Actions"
                width={setPercentage(
                  deleteIcon && historyPopup ? 22 : deleteIcon ? 18 : 10
                )}
                resizable={true}
                filterable={false}
                sortable={false}
                cell={(props) => (
                  <>
                    <img
                      style={{ display: "none" }}
                      className={`cls-img-status-kit-action-store`}
                      alt="active"
                      src={`data:image/png;base64,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`}
                    />
                    <td id="test-kit-id" className="cls-action-button-col">
                      <ActionMenu
                        forceHideEdit={forceHideEdit}
                        data={props.dataItem}
                        additionalMenus={additionalActions}
                        isInlineDeleteAllowed={isInlineDeleteAllowed}
                        isInlineEditAllowed={
                          typeof props.dataItem.isRowEditable !== "undefined"
                            ? props.dataItem.isRowEditable
                            : isInlineEditAllowed
                        }
                        deleteIcon={deleteIcon}
                        deleteIconHolder={deleteIconHolder}
                        tooltipColors={resolvedTooltipColors}
                        deleteDisabled={deleteDisabled}
                        deleteTooltip={deleteTooltip}
                        onDeleteDisabled={onDeleteDisabled}
                        in_edit={() => {
                          onEdit(props)
                        }}
                        delete={() => {
                          onDelete(props)
                        }}
                        cancel={() => {
                          onDiscard(props)
                        }}
                        save={() => {
                          onSave(props)
                        }}
                        menutype={menutype}
                        historyPopup={historyPopup}
                      />
                    </td>
                  </>
                )}
              />
            )
          ) : (
            <Column
              className="cls-action-button-col"
              title="Actions"
              width={setPercentage(actionEdit ? 15 : 10)}
              filterable={false}
              sortable={false}
              cell={(props) => {
                console.log(`val`, props)
                return (
                  <td id="test-kit-id" className="cls-action-button-col">
                    <IconMenu
                      isDisableViewIcon={isDisableViewIcon}
                      deleteTooltip={deleteTooltip}
                      editTooltip={editTooltip}
                      actionEdit={actionEdit}
                      actionDelete={actionDelete}
                      data={props.dataItem}
                      isInlineEditAllowed={
                        typeof props.dataItem.isRowEditable !== "undefined"
                          ? props.dataItem.isRowEditable
                          : isInlineEditAllowed
                      }
                      isInlineDeleteAllowed={isInlineDeleteAllowed}
                      in_edit={() => {
                        onEdit(props)
                      }}
                      delete={() => {
                        onDelete(props)
                      }}
                      cancel={() => {
                        onDiscard(props)
                      }}
                      save={() => {
                        onSave(props)
                      }}
                      view={() => {
                        onView(props)
                      }}
                    />
                  </td>
                )
              }}
            />
          )
        ) : null}
      </TemplateTableUIGrid>
    </>
  )
}

export default MaterialDataGrid
export { MaterialDataGrid }
